export function DownIcon2({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M11 4.58364V17.417M11 17.417L5.5 11.917M11 17.417L16.5 11.917" stroke="#101828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

DownIcon2.displayName = 'DownIcon2';
